$(function () {
	$('.scroll-link').on('click', function (e) {
		e.preventDefault();
		$('body').removeClass('show-menu');
		$('.header-nav').removeClass('is-active');
		$('html').animate({ scrollTop: $($(this).attr('href')).position().top + 'px' }, 600);
	});
});